export enum SUBJECT_TYPE {
  ACADEMIC = "ACADEMIC",
  EXTRA_CURRICULAR = "EXTRA_CURRICULAR",
  GRADE_SPECIFIC = "GRADE_SPECIFIC",
}
